import {SurveysElementsState} from './elements.interfaces';

export const elementsInitialState: SurveysElementsState = {
    ids: [],
    entities: null,
    idOfSelectedEntity: null,
    hidden: []
};
